import React from 'react'

function CustomersHead() {
    return (
        <thead className="CustomersHead">
        <tr>
            <th className="Stt">STT</th>
            <th className="Name">Tên khách hàng</th>
            <th className="Phone">Số điện thoại</th>
            <th className="Address">Địa chỉ</th>
            <th className="Description">Mô tả</th>
            <th className="Source">Nguồn khách hàng</th>
            <th className="Actions"/>
        </tr>
        </thead>
    )
}

export default CustomersHead
